export default "__VITE_ASSET__v2a7yKVW__"